const DownloadIcon = (props) => {
    return (
        <svg
          width={24}
          height={24}
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
        >
          <path
            d="M13 14.293l3.146-3.147a.5.5 0 01.708.708l-4 4a.5.5 0 01-.708 0l-4-4a.5.5 0 01.708-.708L12 14.293V3.5a.5.5 0 011 0v10.793zm7 1.207a.5.5 0 011 0v3a2.5 2.5 0 01-2.5 2.5h-12A2.5 2.5 0 014 18.5v-3a.5.5 0 011 0v3A1.5 1.5 0 006.5 20h12a1.5 1.5 0 001.5-1.5v-3z"
            fill="#002044"
          />
        </svg>
      )
}

export default DownloadIcon